function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_product_cat_retirement",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0967,19.2817 C21.3218,20.0567 20.4789,20.7235 19.5875,21.2827 L17.913,15.6826 L19.0782,15.6826 L19.0782,14.2764 L16.2657,14.2764 L16.2657,9.35449 L16.9688,9.35449 C17.3565,9.35449 17.672,9.66991 17.672,10.0576 L19.0782,10.0576 C19.0782,8.89451 18.132,7.94824 16.9688,7.94824 L5.66292,7.94824 L3.54646,0.870117 L2.19918,1.27296 L6.08723,14.2764 L4.92196,14.2764 L4.92196,15.6826 L6.08723,15.6826 L4.41281,21.2827 C3.52134,20.7235 2.67852,20.0568 1.90354,19.2818 L0.90918,20.2761 C3.87168,23.2386 7.8105,24.8701 12.0001,24.8701 C16.1897,24.8701 20.1285,23.2386 23.091,20.2761 L22.0967,19.2817 Z M11.5271,9.35449 L14.8595,9.35449 L14.8595,14.2764 L11.5271,14.2764 L11.5271,9.35449 Z M6.08334,9.35449 L10.1208,9.35449 L10.1208,14.2764 L7.55498,14.2764 L6.08334,9.35449 Z M5.67037,21.9855 L7.55503,15.6826 L16.4453,15.6826 L18.3299,21.9855 C14.3535,23.9477 9.64669,23.9477 5.67037,21.9855 Z",
  id: "Shape"
})));

var SvgIcProductCatRetirement = function SvgIcProductCatRetirement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatRetirement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_retirement.998682c7.svg";
export { ForwardRef as ReactComponent };